import { Component, OnInit } from '@angular/core';
import { ABOSFunction } from '../../model/ABOSFunction';
import { ABOSLink } from '../../model/ABOSLink';
import { AuthenticationService } from '../../service/authentication.service';
import { Router } from '@angular/router';
import { PermissionHandler } from '../../service/PermissionHandler';
import { ApplicationService } from '../../service/application.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CurrentUser } from '../../../model/CurrentUser';
import { ToastrService } from 'ngx-toastr';
import { ChangePasswordWidgetComponent } from '@baxter-jenkins/authenticator';
import { UpdateStaticInfoWidgetComponent } from '@baxter-jenkins/update-static-info-widget';
import { DarkModeService } from '../../service/dark-mode.service';

@Component({
  selector: 'ch-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
})
export class HomepageComponent extends PermissionHandler implements OnInit {
  coreFunctions: Array<ABOSFunction>;
  otherFunctions: Array<ABOSFunction>;
  links: Array<ABOSLink>;
  currentUser: CurrentUser;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly modalService: BsModalService,
    public readonly darkModeService: DarkModeService,
    private readonly toastrService: ToastrService,
    private readonly router: Router,
  ) {
    super(JSON.parse(localStorage.getItem('currentUser')).permissions);
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.coreFunctions = ApplicationService.coreFunctions;
    this.otherFunctions = ApplicationService.otherFunctions;
    this.links = ApplicationService.links;
  }

  signOut() {
    this.authenticationService.logout().subscribe(() => {
      localStorage.removeItem('currentUser');
      this.modalService.hide(1);
      this.router.navigateByUrl('/login');
    });
  }

  openUpdateStaticDataModal() {
    const modalRef = this.modalService.show(UpdateStaticInfoWidgetComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      animated: false,
      class: 'modal-lg',
    });
    modalRef.content.cancelEvent.subscribe(() => {
      modalRef.hide();
    });
    modalRef.content.updateResultEvent.subscribe(() => {
      modalRef.hide();
      this.toastrService.success('Company successfully modified');
    });
  }

  openChangePasswordModal() {
    const initialState = {
      toastr: this.toastrService,
      includeModal: true,
      gridColumnLayout: 24,
    };
    const modalRef = this.modalService.show(ChangePasswordWidgetComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      animated: false,
      class: 'modal-lg',
      initialState,
    });
    modalRef.content.cancelEvent.subscribe(() => {
      modalRef.hide();
    });
  }
}
